<!--
 * @Description:
 * @Author: PF
 * @Date: 2024-09-19 15:30:10
 * @LastEditors: PF
 * @LastEditTime: 2024-09-19 15:30:10
-->
<!--
 * @Description: 办公用印管理 添加
 * @Author: ZSC
 * @Date: 2023-04-18 15:30:48.595
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-06-12 18:48:45
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用印登记号" prop="yydjh" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.yydjh" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公章" prop="gzid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.gzid" clearable filterable>
                <el-option v-for="item in gzData" :key="item.id" :label="item.zzmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用印事由" prop="yysy">
              <el-input v-model="ruleForm.yysy" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="事由关联号" prop="syglh">
              <el-input v-model="ruleForm.syglh" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用印次数" prop="yycs" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input-number v-model="ruleForm.yycs" :min="1" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用印日期" prop="yyrq">
              <el-date-picker v-model="ruleForm.yyrq" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="用印批准人">
              <el-button class="mr10" type="primary" @click="openPinZhunDanTiao=true">选择</el-button>
              <el-tag class="mr10 mt10" v-if="ruleForm.yypzrid" closable @close="CoursePinZhunClose">{{ruleForm.yrpzrxm}}</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用印批准日期">
              <el-date-picker v-model="ruleForm.yypzrq" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用印申请日期" prop="yysqrq">
              <el-date-picker v-model="ruleForm.yysqrq" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请人">
              <el-button class="mr10" type="primary" @click="openShenQinDanTiao=true">选择</el-button>
              <el-tag class="mr10 mt10" v-if="ruleForm.sqrid" closable @close="CourseShenQinClose">{{ruleForm.sqrxm}}</el-tag>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="执行人">
              <el-button class="mr10" type="primary" @click="openZhiXingDanTiao=true">选择</el-button>
              <el-tag class="mr10 mt10" v-if="ruleForm.zsrid" closable @close="CourseZhiXingClose">{{ruleForm.zsrxm}}</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <jiaozhigongdantiao v-if="openPinZhunDanTiao" v-model:openDanTiao="openPinZhunDanTiao" :row="row" @ReturnData="ReturnPinZhuData" />
  <jiaozhigongdantiao v-if="openShenQinDanTiao" v-model:openDanTiao="openShenQinDanTiao" :row="row" @ReturnData="ReturnShenQinData" />
  <jiaozhigongdantiao v-if="openZhiXingDanTiao" v-model:openDanTiao="openZhiXingDanTiao" :row="row" @ReturnData="ReturnZhiXingData" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect } from '@/api/common.js'

import jiaozhigongdantiao from '@/components/chazhaodaihui/jiaozhigongdantiao.vue'
const props = defineProps({ openAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const openPinZhunDanTiao = ref(false)
const ReturnPinZhuData = (data) => {
  ruleForm.value.yypzrid = data.id
  ruleForm.value.yrpzrxm = data.xm
}
const CoursePinZhunClose = () => {
  ruleForm.value.yypzrid = ''
  ruleForm.value.yrpzrxm = ''
}
const openShenQinDanTiao = ref(false)
const ReturnShenQinData = (data) => {
  ruleForm.value.sqrid = data.id
  ruleForm.value.sqrxm = data.xm
}
const CourseShenQinClose = () => {
  ruleForm.value.sqrid = ''
  ruleForm.value.sqrxm = ''
}
const openZhiXingDanTiao = ref(false)
const ReturnZhiXingData = (data) => {
  ruleForm.value.zsrid = data.id
  ruleForm.value.zsrxm = data.xm
}
const CourseZhiXingClose = () => {
  ruleForm.value.zsrid = ''
  ruleForm.value.zsrxm = ''
}
const gzData = ref()
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      loadSelect({
        url: '/api/v2/bangong/bangongzhizhangguanli/list',
        data: gzData,
        order: 'gzbh',
        sort: 'asc'
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/bangong/bangongyonyinguanli',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
